let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f8iIg")).then(() => parcelRequire('5cuMq'));